import "./FailureMessage.css";
function SuccessMessage({ message }) {
  return <div className="failure-message">{message}</div>;
}

export default SuccessMessage;
